var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVertBetweenSpace24 = function SvgIconVertBetweenSpace24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.651h13v1.7h-13v-1.7ZM18.5 20.351h-13v-1.7h13v1.7ZM11.15 16.536V7.461h1.7v9.075h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 15.72 2.498-2.62 1.086 1.034-2.604 2.733a1.348 1.348 0 0 1-1.959 0l-2.603-2.733 1.086-1.035 2.497 2.622ZM12.98 7.13l2.604 2.734-1.086 1.034L12 8.277l-2.497 2.621-1.086-1.034 2.604-2.734a1.348 1.348 0 0 1 1.958 0Z"
  }))));
};
export default SvgIconVertBetweenSpace24;